import styled, { type StyledComponent } from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Link, type LinkProps } from 'react-router'

export const AppearanceInheritingLink: StyledComponent<LinkProps> = styled(Link)(
  {
    color: 'inherit',
    textDecoration: 'inherit',
  },
  ({ className }) => {
    const cursor = className === 'disabled' ? 'default' : undefined
    return {
      cursor,
    }
  }
)

export const LinkStyled = styled(Link)({
  color: hexColors.black,
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline',
  },
})
